var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHighTemp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "3.6 .2 92.6 96",
    width: 92.6,
    height: 96,
    fill: "#ff914d",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sun",
    stroke: "none",
    strokeDasharray: "none",
    "ffill-opacity": 1,
    strokeOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 57.708216 35 L 65.30822 39.8 L 57.708216 44.6 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.799655,
    cy: 40.599655,
    r: 20.9996885553886
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 39.599655 64 L 34.799655 71.6 L 29.999655 64 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 29.999655 17.19931 L 34.799655 9.59931 L 39.599655 17.19931 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.2 45.399655 L 3.6 40.599655 L 11.2 35.799655 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.365513 27.11238 L 13.385614 18.344254 L 22.153738 20.324153 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 54.96674 53.13716 L 56.94664 61.90528 L 48.178517 59.92538 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22.153738 60.87516 L 13.385614 62.855056 L 15.365513 54.08693 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 49.098915 20.324153 L 57.86704 18.344254 L 55.88714 27.11238 Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Thermometer",
    strokeDasharray: "none",
    fillOpacity: 1,
    strokeOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 78.20198 66.7428 L 78.3 15.9 C 78.3 14.24961 76.94834 12.7 75.3 12.7 C 73.64969 12.7 72.1 14.04961 72.1 15.7 L 72.20264 66.7428 C 68.71319 67.9801 66.2033 71.28284 66.2033 75.19736 C 66.2033 80.1682 70.23171 84.19877 75.20231 84.19877 C 80.16701 84.19877 84.19935 80.1682 84.19935 75.19736 C 84.19935 71.28284 81.6875 67.9801 78.20198 66.7428 Z M 90.20066 60.55629 L 90.20066 15.20105 C 90.20066 6.93139 83.4696 .2 75.20231 .2 C 66.93306 .2 60.202 6.93139 60.202 15.20105 L 60.202 60.55629 C 56.39586 64.45507 54.20069 69.72294 54.20069 75.19736 C 54.20069 86.7855 63.61473 96.2 75.20231 96.2 C 86.78792 96.2 96.2 86.7855 96.2 75.19736 C 96.2 69.72294 94.0068 64.4354 90.20066 60.55629 Z M 75.20231 90.1984 C 66.93306 90.1984 60.202 83.46898 60.202 75.19736 C 60.202 70.41732 62.48961 66.0307 66.2033 63.23744 L 66.2033 15.20105 C 66.2033 10.23217 70.23171 6.2016 75.20231 6.2016 C 80.16701 6.2016 84.19935 10.23217 84.19935 15.20105 L 84.19935 63.23744 C 87.91108 66.01104 90.20066 70.41732 90.20066 75.19736 C 90.20066 83.46898 83.4696 90.1984 75.20231 90.1984 Z",
    fill: "#ff765b"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighTemp);
export default __webpack_public_path__ + "static/media/highTemp.4abd3d89d76f2c7e2b6ea75f539fbe6b.svg";
export { ForwardRef as ReactComponent };